module.exports = __webpack_public_path__ + "static/media/filter-sidebar-checkmark.a36fc0ad.svg";